import { AbstractControl, ValidationErrors } from '@angular/forms';
import { DosageType } from 'src/interfaces/medicine';

/** Ensures the control holds a selected DosageType object, not free text. */
export function dosageTypeSelectedValidator(control: AbstractControl): ValidationErrors | null {
  const value: DosageType | string | null = control.value;

  if (!value || typeof value !== 'object' || typeof value.id !== 'number') {
    return { dosageTypeRequired: true };
  }

  return null;
}
